import { http, createConfig } from 'wagmi';
import { polygon } from 'wagmi/chains';
import { trustWallet } from '@rainbow-me/rainbowkit/wallets';
import {
  tokenPocketWallet,
  walletConnectWallet,
  metaMaskWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import * as chains from 'wagmi/chains';
import { PROJECT_ID } from '../constants';

const allChains = [polygon, ...Object.values(chains)];

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        tokenPocketWallet,
        metaMaskWallet,
        walletConnectWallet,
        trustWallet,
      ],
    },
  ],
  { appName: 'X_STAKING', projectId: PROJECT_ID }
);

export const wagmiConfig = createConfig({
  chains: allChains,
  transports: Object.fromEntries(allChains.map(chain => [chain.id, http()])),
  connectors,
});
